/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Navigate, RouteObject } from 'react-router'
import AdminLayout from './components/layouts/AdminLayout'
import { adminRoutes } from './components/pages/adminRoutes'
import EstatePrintPage from '../../modules/twh/components/estate/EstatePrintPage'
import CenterLayout from './components/layouts/CenterLayout'
import { getSignInLink, getSignOutLink } from '../../modules/auth/lib/authLinks'
import SignInPage from '../../modules/auth/pages/SignInPage'
import SignOutPage from '../../modules/auth/pages/SignOutPage'
import ErrorLayout from './components/layouts/ErrorLayout'
import NotFoundPage from './components/pages/NotFoundPage'
import RequireAuth from '../../modules/auth/components/RequireAuth'
import RouteErrorBoundary from '../../modules/twh/components/RouteErrorBoundary'
import ResetPasswordFormPage from '../../modules/user/components/ResetPasswordFormPage'
import ResetPasswordSuccessPage from '../../modules/user/components/ResetPasswordSuccessPage'
import UpdatePasswordFormPage from '../../modules/user/components/UpdatePasswordFormPage'

export const routes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="/admin" />
  },
  {
    path: '/admin/*',
    element: <RequireAuth permissions={['access:admin']}>
      <AdminLayout />
    </RequireAuth>,
    children: adminRoutes,
    errorElement: <AdminLayout>
      <RouteErrorBoundary />
    </AdminLayout>
  },
  {
    path: '/admin/estates/:id/print',
    element: <RequireAuth permissions={['access:admin']}>
      <EstatePrintPage />
    </RequireAuth>
  },
  {
    element: <CenterLayout />,
    children: [
      {
        path: '/password/*',
        children: [
          {
            path: 'reset',
            element: <ResetPasswordFormPage />
          },
          {
            path: 'reset/success',
            element: <ResetPasswordSuccessPage />
          },
          {
            path: 'update',
            element: <UpdatePasswordFormPage />
          }
        ]
      },
      {
        path: getSignInLink(),
        element: <SignInPage />
      },
      {
        path: getSignOutLink(),
        element: <SignOutPage />
      }
    ]
  },
  {
    path: '*',
    element: <ErrorLayout>
      <NotFoundPage />
    </ErrorLayout>
  }
]
